import { useCallback, useContext } from 'react'
import { OAuth2Context } from '../context/oauth2-context'

const generateState = () => {
    const validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let array = new Uint8Array(40)
    window.crypto.getRandomValues(array)
    array = array.map((x) => validChars.codePointAt(x % validChars.length))
    return String.fromCharCode.apply(null, array)
}

const formatAuthorizeUrl = (authorizeUrl, clientId, redirectUri, scope, state, responseType, extraQueryParameters) => {
    const query = objectToQuery({
        response_type: responseType,
        client_id: clientId,
        redirect_uri: redirectUri,
        scope,
        state,
        ...extraQueryParameters,
    })
    return `${authorizeUrl}?${query}`
}

const objectToQuery = (object) => {
    return new URLSearchParams(object).toString()
}

const popupHeight = 700
const popupWidth = 600

export const useOAuth2 = (props) => {
    const { campaignId, responseType, redirectUri } = props

    const context = useContext(OAuth2Context)

    const getAuth = useCallback(
        (parameters, page = 'platform', popup = false) => {
            const state = generateState()
            context.setState({
                state: state,
                platform: parameters.id,
                campaignId: campaignId,
                page: page,
            })

            const extraQueryParameters = parameters.extra
                ? {
                      ...props.extraQueryParameters,
                      ...JSON.parse(parameters.extra),
                  }
                : props.extraQueryParameters
            const authUrl = formatAuthorizeUrl(
                parameters.authorizeUrl,
                parameters.clientId,
                redirectUri,
                parameters.scope,
                state,
                responseType,
                extraQueryParameters
            )

            const left = window.screenX + (window.outerWidth - popupWidth) / 2
            const top = window.screenY + (window.outerHeight - popupHeight) / 2

            popup
                ? window.open(
                      authUrl,
                      'fb-oauth',
                      [
                          `width=${popupWidth}`,
                          `height=${popupHeight}`,
                          `top=${top}`,
                          `left=${left}`,
                          'resizable=no',
                          'toolbar=no',
                          'menubar=no',
                          'status=no',
                          'location=no', // disables location bar in some browsers
                      ].join(',')
                  )
                : window.location.replace(authUrl)

            if (popup) {
                const listener = (event) => {
                    if (event.origin !== window.origin) return

                    if (event.data?.type === 'oauth:callback') {
                        const query = event.data.query
                        window.location.href = `/callback${query}`
                    }
                }
                window.addEventListener('message', listener)
            }
        },
        [redirectUri, campaignId, context, responseType, props.extraQueryParameters]
    )

    return { getAuth }
}
